import React from 'react';
import { ForgotPasswordContainer } from '../../auth';
import { shared } from '../../config';

const sitekey = shared.GOOGLE_RECAPTCHA_SITE_KEY;

const ForgotPasswordPage = () => {
  return <ForgotPasswordContainer sitekey={sitekey} />;
};

ForgotPasswordPage.displayName = 'ForgotPasswordPage';

export default ForgotPasswordPage;
